module.exports = __webpack_public_path__ + "img/pfood.dcaa3a04.jpg";